import { useAuth } from "./core/contexts/AuthContext";
import Login from "./features/login/Login";
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { MeetingsRoute } from "./features/meetings/MeetingsRoute";

function App() {
  const { isAuthenticated } = useAuth()

  return (
    <div className="app-container">
      {!isAuthenticated && <Login />}
      {isAuthenticated &&  <MeetingsRoute />}
    </div>
  );
}

export default App;
